/**
 * Created by i.lovenkov on 25.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _Bread = require('./Bread');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    BreadsView: {
        displayName: 'BreadsView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/CartProduct/Breads/default/BreadsView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var BreadsView = _wrapComponent('BreadsView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(BreadsView, _Component);

    function BreadsView() {
        (0, _classCallCheck3.default)(this, BreadsView);
        return (0, _possibleConstructorReturn3.default)(this, (BreadsView.__proto__ || (0, _getPrototypeOf2.default)(BreadsView)).apply(this, arguments));
    }

    (0, _createClass3.default)(BreadsView, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                categories = _props.categories,
                lang = _props.lang,
                res = void 0;


            if (categories) {
                res = categories.map(function (item, i) {
                    var title = lang[item.title] || item.title;

                    return _react3.default.createElement(_Bread.Bread, {
                        key: 'Bread_' + i,
                        id: item.id,
                        title: title,
                        onClick_Link: _this2.props.onClick_Link
                    });
                });
            }

            return _react3.default.createElement(
                'div',
                { className: 'brand bread' },
                res
            );
        }
    }]);
    return BreadsView;
}(_react2.Component), _class.defaultProps = {
    onClick_Link: function onClick_Link() {}
}, _temp));

exports.default = BreadsView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/CartProduct/Breads/default/BreadsView.jsx
// module id = 1625
// module chunks = 0